import script from "./Spin.vue?vue&type=script&setup=true&lang=ts"
export * from "./Spin.vue?vue&type=script&setup=true&lang=ts"

import "./Spin.vue?vue&type=style&index=0&id=17f25bd2&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17f25bd2"]])

export default __exports__